// extracted by mini-css-extract-plugin
module.exports = {"footer":"PromotionFooter_footer__16P3N","footerText":"PromotionFooter_footerText__3TOoy","footerLogo":"PromotionFooter_footerLogo__rFJZu"};